import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { LocalStorage } from './LocalStorage';
import { environment } from './../../environments/environment';
import { ConfirmationService } from 'primeng/api';
type deleteById2Type = {
    url:string, 
    deleteId:string,
    confirm:ConfirmationService,
    success:Function
}
@Injectable()
export class HttpHelpUtilsWater {
  public http: HttpClient;
  public storage: LocalStorage;

  public loadingText = '加载中';
  public loadingBlock = false;
  public loadingGif = "assets/file/image/loading-b.gif";
  public pageHeight = 'calc(100vh - 102px)';                // 页面header高度
  public menuWidth = '240px';                               // 侧边栏宽度
  public dialogBlock = false;

  constructor(
    http: HttpClient,
    storage: LocalStorage) {
    this.http = http;
    this.storage = storage;
  }
  exportData(url) {
    return this.http.get(this.checkFullPath(url), { responseType: 'blob' });
  }
  downLoad(url) {
    return this.http.get(this.checkFullPath(url), { responseType: 'blob' });
  }
  checkFullPath(url: string) {
    if (url.indexOf('http') != -1 || url.indexOf('https') != -1 || url.indexOf('https') != -1) {
      return url
    } 

    return  environment.baseUrlWater + url;
  }

  getError(error): {} {
    let returnOption = {code: 2};
    switch (error.status) {
      case 403:
        returnOption['message'] = '您得权限不足，服务器拒绝访问';
        break;
      case 404:
        returnOption['message'] = '服务器未响应当前地址，请联系客服人员反馈';
        break;
      case 504:
        returnOption['message'] = '您好：服务器正在重启，请稍后重试！';
        break;
      default:
        returnOption['message'] = '【'+ error.status +'】未知错误，请联系管理员！';
        break;
    }
    return returnOption;
  }

    // get
    public get(url: string, params?: any, responseType?: 'json' | 'blob' | 'text' | 'arraybuffer') {
        let httpParams = new HttpParams();
        if (params) {
            // 只有当 params 中明确包含 'page' 或 'rows' 时才添加分页参数
            // 这样可以让某些接口使用自定义的分页参数名（如 pageNum, pageSize）
            const hasPageParams = params.hasOwnProperty('page') || params.hasOwnProperty('rows');
            
            if (hasPageParams) {
                if (params['page']) {
                    params['page'] += 1
                } else {
                    params['page'] = 1;
                }
                params['size'] = params['rows'];
                params['current'] = params['page'];
            }
            
            for (const key in params) {
                if (params[key] === false || params[key] || params[key] === 0) {
                    httpParams = httpParams.set(key, params[key].toString().trim());
                }
            }
        }

        const req: any = {
            params: httpParams,
            headers:{
                Token:window.localStorage.getItem("waterToken")
            }
        };
        
        if (responseType) {
            req.responseType = responseType;
        }
        
        console.log("req", req);
        return Promise.race([new Promise((resolve, reject) => {
            this.http.get(this.checkFullPath(url), req).subscribe(
                res => {
                    console.log('HTTP GET Response:', url, res);
                    // 对于车辆/司机过期证件查询接口，删除成功消息，避免显示"发送成功"提示
                    if (url.includes('truckCertificate/page') || url.includes('driverCertificate/page')) {
                        console.log('检测到过期证件查询接口，原始响应:', JSON.stringify(res));
                        // 支持两种响应格式：status: "success" 或 code: 0
                        if (res && ((res['code'] == 0 || res['code'] == '0') || res['status'] == 'success')) {
                            console.log('删除message前:', res['message'], res['msg']);
                            delete res['message'];
                            delete res['msg'];
                            console.log('删除message后:', res['message'], res['msg']);
                        }
                    }
                    // 对于 get-card-check-size 接口，也删除成功消息
                    if (url.includes('get-card-check-size')) {
                        console.log('检测到get-card-check-size接口');
                        if (res && (res['status'] == 'success' || res['code'] == 0 || res['code'] == '0')) {
                            console.log('删除message前:', res['message']);
                            delete res['message'];
                            delete res['msg'];
                            console.log('删除message后:', res['message']);
                        }
                    }
                    resolve(res)
                },
                error => {
                    resolve(this.getError(error))
                }
            )
        }),
        new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({code: 99, message: '访问已超时'})
            }, 120000);
        })]);
    }

    // post
    public post(url: string, data?: object) {
        return Promise.race([
            new Promise((resolve, reject) => {
                this.http.post(this.checkFullPath(url), data).subscribe(
                res => {
                    resolve(res)
                },
                error => {
                    resolve(this.getError(error))
                }
                )
            }),
            new Promise((resolve, reject) => {
                setTimeout(() => {
                resolve({code: 99, message: '访问已超时'})
                }, 30000);
            })
        ]);
    }
    // 保存
    public saveData({ url=null, validateForm=null, noForm=false, options={}, confirmMsg=null, confirmTitle=null, success=null, error=null,  
        confirm = null, subUrl = null, formType = null, successMsg='' }): void {
        confirm.confirm({
            message: confirmMsg || '确定保存数据吗？',
            icon: 'pi pi-exclamation-triangle',
            header: confirmTitle || '保存确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                this.loadingBlock = true;
                subUrl = (subUrl == null ? '' : subUrl);
                this.post(url + subUrl, options).then(res => {
                    success && success(res)
                }).catch(err => {
                    console.log(err);
                });
            },
            reject: () => {

            },
            key: 'confirm'
        });
        }

    // 保存
    public save({ url=null, validateForm=null, noForm=false, options={}, confirmMsg=null, confirmTitle=null, success=null, error=null,  
                confirm = null, subUrl = null, formType = null, successMsg='' }): void {
        if (!noForm) {
            if (validateForm) {
                if (validateForm.controls.length !== 0) {
                for (const i in validateForm.controls) {
                    if (validateForm.controls[i].invalid) {
                    validateForm.controls[i].markAsDirty();
                    validateForm.controls[i].updateValueAndValidity();
                    return;
                    }
                    options[i] = validateForm.controls[i].value;
                }
                } else {
                return
                }
            }
        }
        confirm.confirm({
            message: confirmMsg || '确定保存数据吗？',
            icon: 'pi pi-exclamation-triangle',
            header: confirmTitle || '保存确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                this.loadingBlock = true;
                subUrl = (subUrl == null ? '' : subUrl);
                this.post(url + subUrl, options).then(res => {
                    success && success(res)
                }).catch(err => {
                    console.log(err);
                });
            },
            reject: () => {

            },
            key: 'confirm'
        });
    }

     // 删除
     public deleteById({ url=null, deleteId=null, confirmMsg=null, confirmTitle=null, success=null, error=null, confirm = null,successMsg=''  },otherParams = {}): void {
        const that = this;
        confirm.confirm({
            message: confirmMsg || '确定删除选中的数据吗？',
            icon: 'pi pi-exclamation-triangle',
            header: confirmTitle || '删除确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                that.loadingBlock = true;
                that.get(url, { id: deleteId ,...otherParams}).then(res => {
                success && success(res)
                }).catch(err => {
                console.log(err);
                });
            },
            reject: () => {

            },
            key: 'confirm'
        });
    }
    // 
    public deleteById2({ url, deleteId, confirm ,success }:deleteById2Type): void {
        const that = this;
        confirm.confirm({
            message: '确定删除选中的数据吗？',
            icon: 'pi pi-exclamation-triangle',
            header: '删除确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                that.loadingBlock = true;
                that.http.delete(url,{
                   params:{
                     id:deleteId
                   }
                }).subscribe(res => {
                   
                    that.loadingBlock = false;
                    success(res)
                })
            },
            reject: () => {

            },
            key: 'confirm'
        });
    }
    // 删除post
    public deleteData({ url=null, deleteId=null, confirmMsg=null, confirmTitle=null, success=null, error=null, confirm = null,successMsg=''  }): void {
        const that = this;
        confirm.confirm({
            message: confirmMsg || '确定删除选中的数据吗？',
            icon: 'pi pi-exclamation-triangle',
            header: confirmTitle || '删除确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                that.loadingBlock = true;
                that.post(url, { id: deleteId }).then(res => {
                success && success(res)
                }).catch(err => {
                console.log(err);
                });
            },
            reject: () => {

            },
            key: 'confirm'
        });
    }
    // 多删除
    public delete({ url=null, deleteId=null, confirmMsg=null, confirmTitle=null, success=null, error=null, confirm = null,successMsg=''  }): void {
        const that = this;
        confirm.confirm({
            message: confirmMsg || '确定删除选中的数据吗？',
            icon: 'pi pi-exclamation-triangle',
            header: confirmTitle || '删除确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                that.loadingBlock = true;
                that.get(url, { ids: deleteId }).then(res => {
                success && success(res)
                }).catch(err => {
                console.log(err);
                });
            },
            reject: () => {

            },
            key: 'confirm'
        });
    }
        // 单删除
        public deleteOne({ url=null, deleteId=null, confirmMsg=null, confirmTitle=null, success=null, error=null, confirm = null,successMsg='',method = 'get',deleteIdKey = 'id',isParams = false  }): void {
            const that = this;
            let params =  '?' + deleteIdKey + '=' + deleteId
            confirm.confirm({
                message: confirmMsg || '确定删除选中的数据吗？',
                icon: 'pi pi-exclamation-triangle',
                header: confirmTitle || '删除确认',
                acceptLabel: '确定',
                rejectLabel: '取消',
                rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
                accept: () => {
                    that.loadingBlock = true;
                    that[method](url + (isParams ? params : ''), { [deleteIdKey]: deleteId }).then(res => {
                    success && success(res)
                    }).catch(err => {
                    console.log(err);
                    });
                },
                reject: () => {
                },
                key: 'confirm'
            });
        }
    // 审核
    public check({ url=null, deleteId=null, confirmMsg=null, confirmTitle=null, success=null, error=null, confirm = null,successMsg=''  }): void {
        const that = this;
        confirm.confirm({
            message: confirmMsg || '确定审核通过选中的数据吗？',
            icon: 'pi pi-exclamation-triangle',
            header: confirmTitle || '审核确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                that.loadingBlock = true;
                that.get(url, { ids: deleteId }).then(res => {
                    success && success(res)
                }).catch(err => {
                    console.log(err);
                });
            },
            reject: () => {

            },
            key: 'confirm'
        });
    }

    // 作废——by zwb 2024-08-28 add
    public cancel({ url=null, cancelId=null, confirmMsg=null, confirmTitle=null, success=null, error=null, confirm = null,successMsg=''  }): void {
        const that = this;
        confirm.confirm({
            message: confirmMsg || '确定作废选中的数据吗？',
            icon: 'pi pi-exclamation-triangle',
            header: confirmTitle || '作废确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                that.loadingBlock = true;
                that.get(url, { id: cancelId }).then(res => {
                success && success(res)
                }).catch(err => {
                console.log(err);
                });
            },
            reject: () => {

            },
            key: 'confirm'
        });
    }

    public cancelData({ url=null, data=null, confirmMsg=null, confirmTitle=null, success=null, error=null, confirm = null,successMsg=''  }): void {
        const that = this;
        console.log(1111111111)
        confirm.confirm({
            message: confirmMsg || '确定作废选中的数据吗？',
            icon: 'pi pi-exclamation-triangle',
            header: confirmTitle || '作废确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                that.loadingBlock = true;
                that.post(url, data).then(res => {
                success && success(res)
                }).catch(err => {
                console.log(err);
                });
            },
            reject: () => {

            },
            key: 'confirm'
        });
    }
   
}
